import { __require as r } from "../node_modules/use-sync-external-store/shim/with-selector.mjs";
var t = r();
export {
  t as w
};
